import { Box } from '@spark-web/box';
import { Divider } from '@spark-web/divider';
import { Stack } from '@spark-web/stack';
import LogoImage from '../../../assets/brighte-logo.svg?react';
import { getFinancialProductLogo } from './helper';

type LogoProps = {
  financialProductId?: string;
};

export const Header = ({ financialProductId }: LogoProps) => {
  const FinancialProductLogo = getFinancialProductLogo(financialProductId);

  return (
    <Stack gap="xxlarge" alignSelf="center">
      <Box flex={1} justifyContent="center" alignItems="center" display="flex" gap="medium">
        <LogoImage />
        {FinancialProductLogo && (
          <Box display="flex" flex={1} gap="medium" data-testid="partner-logo">
            <Divider vertical />
            {FinancialProductLogo}
          </Box>
        )}
      </Box>
    </Stack>
  );
};
